// Re-export shared impersonation utilities with debugging
import {
  getImpersonationCookie as _getImpersonationCookie,
  setImpersonationCookie,
  deleteImpersonationCookie,
  IMPERSONATION_COOKIE_NAME,
  getImpersonationKitCookie as _getImpersonationKitCookie,
  setImpersonationKitCookie,
  deleteImpersonationKitCookie,
  IMPERSONATION_KIT_COOKIE_NAME,
} from '@repo/utils';

// Wrapper with debugging
export function getImpersonationCookie(): string | undefined {
  const result = _getImpersonationCookie();
  console.log('🔍 getImpersonationCookie: document.cookie:', document.cookie);
  console.log('🔍 getImpersonationCookie: result:', result);
  return result;
}

// Wrapper with debugging for kit cookie
export function getImpersonationKitCookie(): string | undefined {
  const result = _getImpersonationKitCookie();
  console.log('🔍 getImpersonationKitCookie: result:', result);
  return result;
}

export {
  setImpersonationCookie,
  deleteImpersonationCookie,
  IMPERSONATION_COOKIE_NAME,
  setImpersonationKitCookie,
  deleteImpersonationKitCookie,
  IMPERSONATION_KIT_COOKIE_NAME,
};